import { useEffect, useRef } from 'react';
import { Html5Qrcode } from 'html5-qrcode';

interface LeitorQRProps {
  id: string; // id do elemento onde o vídeo será montado (precisa ser único na tela)
  ativo: boolean;
  aoLer: (codigo: string) => void;
  aoErroCamera: (mensagem: string) => void;
}

const CONFIG = { fps: 10, qrbox: { width: 240, height: 240 } };

// Leitor de QR pela câmera traseira (mesma engine html5-qrcode da barraca e
// da portaria). Usado no "Entrar numa função" para ler o QR do cartaz.
export default function LeitorQR({ id, ativo, aoLer, aoErroCamera }: LeitorQRProps) {
  const ativoRef = useRef(ativo);
  ativoRef.current = ativo;
  const aoLerRef = useRef(aoLer);
  aoLerRef.current = aoLer;
  const inicioRef = useRef<Promise<unknown> | null>(null);

  useEffect(() => {
    let desmontado = false;
    const scanner = new Html5Qrcode(id);
    const aoDecodificar = (texto: string) => {
      if (!ativoRef.current) return;
      aoLerRef.current(texto);
    };
    const semQr = () => {
      /* frame sem QR: normal */
    };

    const inicio = scanner.start(
      { facingMode: 'environment' },
      CONFIG,
      aoDecodificar,
      semQr,
    );
    inicioRef.current = inicio;
    inicio.catch((err) => {
      const msg =
        typeof err === 'string'
          ? err
          : (err as { message?: string })?.message || 'Câmera indisponível.';
      aoErroCamera(msg);
    });

    return () => {
      desmontado = true;
      const p = inicioRef.current ?? Promise.resolve();
      p.catch(() => undefined).finally(() => {
        try {
          scanner
            .stop()
            .then(() => scanner.clear())
            .catch(() => {
              /* câmera já liberada */
            });
        } catch {
          /* não estava lendo */
        }
      });
      void desmontado;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  return (
    <div className="relative h-full w-full overflow-hidden bg-black">
      <div id={id} className="h-full w-full" />
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[220px] w-[220px] -translate-x-1/2 -translate-y-1/2">
        <span className="absolute left-0 top-0 h-8 w-8 border-l-4 border-t-4 border-white/70" />
        <span className="absolute right-0 top-0 h-8 w-8 border-r-4 border-t-4 border-white/70" />
        <span className="absolute bottom-0 left-0 h-8 w-8 border-b-4 border-l-4 border-white/70" />
        <span className="absolute bottom-0 right-0 h-8 w-8 border-b-4 border-r-4 border-white/70" />
      </div>
    </div>
  );
}